import environment from "./environments/environment";


export const clientId = environment.clientId;
export const authority = environment.authority;
export const redirectUri = environment.ApplicationURI;